import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const BILLS_COLLECT_MONEY = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'BILLS_COLLECT_MONEY')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: '/cgs/api/socialpay/sb/queryBillInfoByToken',
        method: 'POST',
        body: data,
        requestAction: BILLS_COLLECT_MONEY.INIT_REQUEST,
        successAction: BILLS_COLLECT_MONEY.INIT_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [BILLS_COLLECT_MONEY.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [BILLS_COLLECT_MONEY.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'billsCollectMoney',
    reducerMap: {
      billsCollectMoneyState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
